import type { PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

export function Container({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <article
      className={twMerge(
        '4xl:mx-0 container mt-2 ml-0 flex w-full flex-col justify-start gap-4 px-6 md:flex-row',
        className
      )}
    >
      {children}
    </article>
  );
}

export function LeftSection({
  children,
  className,
  forceFullWidth = false,
  forceCenter = false,
}: PropsWithChildren<{ className?: string; forceFullWidth?: boolean; forceCenter?: boolean }>) {
  return (
    <main
      className={twMerge(
        'flex flex-col gap-4',
        forceFullWidth ? 'max-w-full' : '3xl:max-w-[calc(100%-25.5rem)] lg:max-w-[calc(100%-18.5rem)]',
        forceCenter ? 'mx-auto' : '',
        'flex-1',
        className
      )}
    >
      {children}
    </main>
  );
}

export function RightSection({ id, children, className }: PropsWithChildren<{ id?: string; className?: string }>) {
  return (
    <aside className={twMerge('3xl:w-[24rem] min-w-76 shrink-0 grow-0 md:w-84', className)}>
      <div id={id} className="top-37.75 flex flex-col gap-4 md:sticky">
        {children}
      </div>
    </aside>
  );
}

export function FormLayout({ className, ...rest }: PropsWithChildren<{ className?: string }>) {
  return <section className={twMerge('mt-9 grid grid-cols-12 gap-x-4 gap-y-7 lg:gap-x-6', className)} {...rest} />;
}
